module.exports = __webpack_public_path__ + "static/assets/b2ee4e678c8ba52903ac913a996eef82.svg";